import { LoginContainer } from 'src/containers/Authentication';
import { usePageMeta } from 'src/hooks';
import { AuthShell } from 'src/components/Layout';

const LoginPage = () => {
  usePageMeta('Login');

  return (
    <AuthShell>
      <LoginContainer />
    </AuthShell>
  );
};

export default LoginPage;
